import { client } from './client'
import type { SentChatAttachment } from '@/types/chat'

export const CHAT_ATTACHMENT_UPLOAD_TIMEOUT_MS = 120_000

export const chatAttachmentsApi = {
    getByChat: (projectId: string, chatId: string) =>
        client.get<SentChatAttachment[]>(`/projects/${projectId}/chats/${chatId}/attachments`).then(r => r.data),

    upload: (projectId: string, chatId: string, files: File[], signal?: AbortSignal) => {
        const formData = new FormData()
        files.forEach(file => formData.append('Files', file))
        return client.post<{ attachments: Array<{ id: string; fileName: string }> }>(
            `/projects/${projectId}/chats/${chatId}/attachments/upload`,
            formData,
            { headers: { 'Content-Type': undefined }, timeout: CHAT_ATTACHMENT_UPLOAD_TIMEOUT_MS, signal }
        ).then(r => r.data)
    },

    delete: (projectId: string, chatId: string, attachmentId: string) =>
        client.delete(`/projects/${projectId}/chats/${chatId}/attachments/${attachmentId}`),
}
